(() => {
	const roots = document.querySelectorAll("[data-snowboard-product]");

	roots.forEach((root) => {
		const mediaEl = root.querySelector("[data-snowboard-media-swiper]");
		const variantEl = root.querySelector("[data-snowboard-variant-swiper]");
		const specEl = root.querySelector("[data-snowboard-spec-swiper]");

		let mediaSwiper = null;
		let variantSwiper = null;
		let specSwiper = null;

		let syncing = false;
		let activeIndex = Number(root.dataset.selectedVariantIndex || 0);
		const reinforcementPanel = root.querySelector("[data-snowboard-reinforcement-panel]");
		const reinforcementDataEl = root.querySelector("[data-snowboard-reinforcement-data]");
		const techDataEl = root.querySelector("[data-snowboard-tech-data]");
		const priceEl = root.querySelector("[data-snowboard-price]");
		let reinforcementData = [];
		let techData = [];

		if (reinforcementDataEl) {
			try {
				reinforcementData = JSON.parse(reinforcementDataEl.textContent || "[]");
			} catch {
				reinforcementData = [];
			}
		}

		if (techDataEl) {
			try {
				techData = JSON.parse(techDataEl.textContent || "[]");
			} catch {
				techData = [];
			}
		}

		const getPanelChild = (panel, selector) => {
			if (!panel) return null;
			return panel.matches(selector) ? panel : panel.querySelector(selector);
		};

		const updatePrice = (index) => {
			const priceData = techData[index]?.price;
			if (!priceEl || !priceData) return;

			const base = priceEl.querySelector("[data-snowboard-price-base]");
			const tax = priceEl.querySelector("[data-snowboard-price-tax]");
			if (base && priceData.base) base.textContent = priceData.base;
			if (tax && priceData.tax) tax.textContent = priceData.tax;
		};

		const updateTechPanel = (key, itemData) => {
			const panel = root.querySelector(`[data-snowboard-tech-panel="${key}"]`);
			if (!panel) return;

			const keepPanel = panel.hasAttribute("data-snowboard-tech-keep-panel");
			const hasData = Boolean(itemData);
			panel.hidden = !hasData && !keepPanel;

			const content = getPanelChild(panel, "[data-snowboard-tech-content]");
			if (content) content.hidden = !hasData;
			if (!hasData) return;

			const media = getPanelChild(panel, "[data-snowboard-tech-media]");
			const heading = getPanelChild(panel, "[data-snowboard-tech-heading]");
			const description = getPanelChild(panel, "[data-snowboard-tech-description]");
			const imageData = itemData.image;
			let hasMedia = false;

			if (media) {
				let image = media.querySelector("img");
				if (imageData && imageData.src) {
					if (!image) {
						image = document.createElement("img");
						image.loading = "lazy";
						image.className = "bl_mediaText_img";
						media.insertBefore(image, heading || null);
					}
					image.removeAttribute("srcset");
					image.removeAttribute("width");
					image.removeAttribute("height");
					image.src = imageData.src;
					image.alt = imageData.alt || itemData.heading || "";
					image.hidden = false;
					hasMedia = true;
				} else if (image) {
					image.hidden = true;
				}
			}

			if (heading) {
				const showHeading = Boolean(itemData.showContentHeading && itemData.heading);
				heading.textContent = itemData.heading || "";
				heading.hidden = !showHeading;
				hasMedia = hasMedia || showHeading;
			}

			if (media) media.hidden = !hasMedia;
			if (content) content.classList.toggle("is_media", Boolean(imageData && imageData.src));

			if (description) {
				description.innerHTML = itemData.descriptionHtml || "";
				description.hidden = !itemData.descriptionHtml;
			}
		};

		const updateVariantTech = (index) => {
			if (techData.length === 0) return;
			const variantData = techData[index] || {};
			updatePrice(index);
			updateTechPanel("arches", variantData.arches);
			updateTechPanel("construction", variantData.construction);
			updateTechPanel("shape", variantData.shape);
		};

		const updateReinforcement = (index) => {
			if (!reinforcementPanel || reinforcementData.length === 0) return;

			const variantData = reinforcementData[index] || {};
			let hasVisibleImage = false;

			["top", "bottom"].forEach((position) => {
				const item = reinforcementPanel.querySelector(`[data-snowboard-reinforcement-item="${position}"]`);
				if (!item) return;

				const media = item.querySelector("[data-snowboard-reinforcement-media]");
				const imageData = variantData[position];

				if (imageData && imageData.src && media) {
					let image = media.querySelector("img");
					if (!image) {
						image = document.createElement("img");
						image.loading = "lazy";
						image.className = "bl_stackMedia_img";
						media.append(image);
					}
					image.removeAttribute("srcset");
					image.removeAttribute("width");
					image.removeAttribute("height");
					image.src = imageData.src;
					image.alt = imageData.alt || "";
					item.hidden = false;
					hasVisibleImage = true;
				} else {
					item.hidden = true;
				}
			});

			reinforcementPanel.hidden = !hasVisibleImage;
		};

		const setActive = (index) => {
			if (syncing || index === activeIndex) return;
			syncing = true;
			activeIndex = index;
			if (mediaSwiper && mediaSwiper.activeIndex !== index) mediaSwiper.slideTo(index);
			if (specSwiper && specSwiper.activeIndex !== index) specSwiper.slideTo(index);
			root.querySelectorAll("[data-snowboard-variant-slide]").forEach((slide) => {
				slide.toggleAttribute("data-active", Number(slide.dataset.snowboardVariantSlide) === index);
			});
			updateReinforcement(index);
			updateVariantTech(index);
			syncing = false;
		};

		if (window.Swiper && mediaEl) {
			mediaSwiper = new window.Swiper(mediaEl, {
				slidesPerView: 1,
				speed: 400,
				watchOverflow: true,
				on: {
					slideChange: (swiper) => setActive(swiper.activeIndex),
				},
			});
		}

		if (window.Swiper && variantEl) {
			variantSwiper = new window.Swiper(variantEl, {
				slidesPerView: 4,
				spaceBetween: 22,
				watchOverflow: true,
				centerInsufficientSlides: true,
				navigation: {
					nextEl: root.querySelector("[data-snowboard-variant-next]"),
					prevEl: root.querySelector("[data-snowboard-variant-prev]"),
				},
				breakpoints: {
					750: {
						spaceBetween: 30,
					},
				},
			});
		}

		if (window.Swiper && specEl) {
			specSwiper = new window.Swiper(specEl, {
				slidesPerView: 1,
				speed: 400,
				watchOverflow: true,
				navigation: {
					nextEl: root.querySelector("[data-snowboard-spec-next]"),
					prevEl: root.querySelector("[data-snowboard-spec-prev]"),
				},
				on: {
					slideChange: (swiper) => setActive(swiper.activeIndex),
				},
			});
		}

		root.querySelectorAll("[data-snowboard-variant-slide]").forEach((slide) => {
			slide.addEventListener("click", () => {
				setActive(Number(slide.dataset.snowboardVariantSlide));
				if (window.matchMedia("(max-width: 749px)").matches && mediaEl) {
					mediaEl.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			});
		});

		const thumbNav = root.querySelector(".bl_thumbNav");
		if (thumbNav && mediaEl) {
			const placeholder = document.createElement("div");
			placeholder.setAttribute("aria-hidden", "true");
			placeholder.style.display = "none";
			thumbNav.after(placeholder);

			const updateThumbPin = () => {
				const isMobile = window.matchMedia("(max-width: 749px)").matches;
				if (!isMobile) {
					thumbNav.removeAttribute("data-pinned");
					placeholder.style.display = "none";
					return;
				}
				const shouldPin = mediaEl.getBoundingClientRect().bottom < 0;
				if (shouldPin && !thumbNav.hasAttribute("data-pinned")) {
					placeholder.style.height = `${thumbNav.offsetHeight}px`;
					placeholder.style.display = "";
					thumbNav.setAttribute("data-pinned", "");
				} else if (!shouldPin && thumbNav.hasAttribute("data-pinned")) {
					thumbNav.removeAttribute("data-pinned");
					placeholder.style.display = "none";
				}
			};
			window.addEventListener("scroll", updateThumbPin, { passive: true });
			window.addEventListener("resize", updateThumbPin);
			updateThumbPin();
		}

		if (activeIndex > 0) {
			if (mediaSwiper) mediaSwiper.slideTo(activeIndex, 0);
			if (specSwiper) specSwiper.slideTo(activeIndex, 0);
			root.querySelectorAll("[data-snowboard-variant-slide]").forEach((slide) => {
				slide.toggleAttribute("data-active", Number(slide.dataset.snowboardVariantSlide) === activeIndex);
			});
		} else {
			const firstSlide = root.querySelector("[data-snowboard-variant-slide]");
			if (firstSlide) firstSlide.setAttribute("data-active", "");
		}
		updateReinforcement(activeIndex);
		updateVariantTech(activeIndex);

		const lockScroll = () => {
			document.body.style.overflow = "hidden";
		};
		const unlockScroll = () => {
			document.body.style.overflow = "";
		};

		root.querySelectorAll("[data-snowboard-popup-link]").forEach((trigger) => {
			trigger.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopPropagation();

				const targetId = trigger.getAttribute("aria-controls");
				const dialog = targetId ? document.getElementById(targetId) : null;
				if (dialog && typeof dialog.showModal === "function") {
					dialog.showModal();
					lockScroll();
				}
			});
		});

		root.querySelectorAll("[data-snowboard-popup-close]").forEach((closeBtn) => {
			closeBtn.addEventListener("click", () => {
				closeBtn.closest("dialog")?.close();
			});
		});

		root.querySelectorAll("[data-snowboard-popup-target]").forEach((dialog) => {
			dialog.addEventListener("click", (event) => {
				if (event.target === dialog) dialog.close();
			});
			dialog.addEventListener("close", unlockScroll);
		});
	});
})();
